export var SIGNIN = 'SIGNIN';
export var SUCCESS_SIGNIN = 'SUCCESS_SIGNIN';
export var FAILURE_SIGNIN = 'FAILURE_SIGNIN';
export var FETCH_FREEBET = 'FETCH_FREEBET';
export var SUCCESS_FETCH_FREEBET = 'SUCCESS_FETCH_FREEBET';
export var FAILURE_FETCH_FREEBET = 'FAILURE_FETCH_FREEBET';
export var REMEMBER_ME = 'REMEMBER_ME';
export var FETCH_ACTIVATE_EMAIL = 'FETCH_ACTIVATE_EMAIL';
export var SUCCESS_FETCH_ACTIVATE_EMAIL = 'SUCCESS_FETCH_ACTIVATE_EMAIL';
export var DELETE_FETCH_ACTIVATE_EMAIL = 'DELETE_FETCH_ACTIVATE_EMAIL';
export var FAILURE_FETCH_ACTIVATE_EMAIL = 'FAILURE_FETCH_ACTIVATE_EMAIL';



// WEBPACK FOOTER //
// ./src/actions/auth/SignIn.js